module.exports = __webpack_public_path__ + "static/media/solution-4-sec3.f1e33177.png";